import React from "react";
import "./Navbar.css";
import { NavLink as Link } from "react-router-dom";
import logoSSE from "../assets/images/SSE-Horizontal.png";
import logoCIWD from "../assets/images/eiwd-transparent.gif";
function Navbar(props) {
  return (
    <nav className="navbar">
      <a className="navbar-logo" href="https://www.eastinterlake.ca/" target="_blank" rel="noreferrer">
        <img src={logoCIWD} alt="navbar-logo" />
      </a>

      <div className="navbar-menus">
        {props.pages.map((page, index) =>
          page.disabled ? (
            <></>
          ) : (
            <Link key={index} to={page.url} className="navbar-menu">
              {page.title}
            </Link>
          )
        )}
      </div>
      <a className="navbar-logo" href="https://strategicsystemsengineering.ca/" target="_blank" rel="noreferrer">
        <img src={logoSSE} alt="navbar-logo" />
      </a>
    </nav>
  );
}

export default Navbar;
